import React from "react";
import "./MetricCard.css";

export default function MetricCard({ label, value, accent, className = "mfg-metric-card" }) {
  return (
    <div className={className}>
      <div style={{ fontSize: 12, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 800, color: accent || "#0f2d5c" }}>{value ?? "—"}</div>
    </div>
  );
}
